import BaseFormPresenter from "../../../base/BaseFormPresenter";

class OrientationFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async onSave(termsAgreed, signature) {
    const collection = this.view.getCollectionName();
    const { ...updatedObject } = this.object;
    updatedObject.termsAgreed = termsAgreed;
    // updatedObject.signature = signature;
    updatedObject.applicant = { id: updatedObject?.applicant?.id };
    updatedObject.coordinator = { id: updatedObject?.coordinator?.id };
    updatedObject.recruiter = { id: updatedObject?.recruiter?.id };
    updatedObject.orientationDate = new Date().toISOString();

    try {
      this.view.showProgress();
      this.object = await this.upsertUseCase.execute(collection, updatedObject);
      this.view.hideProgress();
      this.view.setObject(this.object);
      this.view.showSuccess("Data Saved Successfully");
    } catch (error) {
      this.view.showError(error);
      console.log(error);
    }
  }
}

export default OrientationFormPresenter;
